var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9934_28846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83154 12.209C2.83154 12.1118 2.8443 12.0182 2.86842 11.9288C2.88616 11.8621 2.83721 11.7969 2.7684 11.7969H0.658101C0.43111 11.7969 0.23675 11.9742 0.232494 12.2012C0.228237 12.4324 0.414086 12.6204 0.644623 12.6204H2.76911C2.83792 12.6204 2.88686 12.5552 2.86913 12.4885C2.84501 12.3991 2.83225 12.3055 2.83225 12.2083L2.83154 12.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3408 11.7988H5.27946C5.21065 11.7988 5.1617 11.8641 5.17944 11.9308C5.20355 12.0201 5.21632 12.1138 5.21632 12.211C5.21632 12.3081 5.20355 12.4018 5.17944 12.4911C5.1617 12.5578 5.21065 12.6231 5.27946 12.6231H15.3543C15.5841 12.6231 15.77 12.4344 15.7664 12.2039C15.7622 11.9769 15.5678 11.7995 15.3408 11.7995V11.7988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4715 0.378906H1.52946C0.894029 0.378906 0.378906 0.894029 0.378906 1.52946V8.82579C0.378906 9.46123 0.894029 9.97635 1.52946 9.97635H14.4715C15.1069 9.97635 15.622 9.46123 15.622 8.82579V1.52946C15.622 0.894029 15.1069 0.378906 14.4715 0.378906Z",
    stroke: "white",
    strokeWidth: 0.878623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17383 7.58179V2.85046C6.17383 2.72419 6.31357 2.64829 6.41926 2.71781L9.96457 5.0395C10.0596 5.10121 10.0603 5.24024 9.9667 5.30337L6.42139 7.71302C6.3157 7.78467 6.17383 7.70947 6.17383 7.58179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73166 12.2959C4.77968 11.9059 4.50246 11.5508 4.11247 11.5028C3.72248 11.4548 3.3674 11.732 3.31938 12.122C3.27135 12.512 3.54857 12.8671 3.93856 12.9151C4.32855 12.9631 4.68363 12.6859 4.73166 12.2959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9934_28846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.9214,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavi);
export default __webpack_public_path__ + "static/media/navi.78f898a3.svg";
export { ForwardRef as ReactComponent };